import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PerformanceThresholds from "./routes/PerformanceThresholds";
import EmailDigest from "./routes/EmailDigest";

export default store => {
  return {
    path: "settings",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "settings" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [PerformanceThresholds(store), EmailDigest(store)],
  };
};
